import React from 'react';
import styled from 'styled-components';

import { Tooltip, Icon } from '../../../../../components';

const VisibilityHeaderRendererContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const VisibilityHeaderRenderer = () => (
  <VisibilityHeaderRendererContainer>
    Visible{' '}
    <Tooltip
      content='If checked, the data is included in the Supper AI prompt.'
      placement='top-end'
    >
      <Icon displaySize={20} name='information' color='var(--content-subtitle)' />
    </Tooltip>
  </VisibilityHeaderRendererContainer>
);

export { VisibilityHeaderRenderer };
